(function (algolia) {

	function searchRequest(tag, query) {
		let index = algolia.externals.algoliasearch(
			algolia.config.app_id,
			algolia.config.search_api_key
		).initIndex(
			algolia.config.index_prefix + 'products',
		)

		if (tag === '') {
			return index.search(query, {
				distinct: 1,
				hitsPerPage: 50
			})
		} else {
			if (tag === 'playerType') {
				return index.search('', {
					filters: `named_tags_names:${tag}`,
					distinct: 1,
					hitsPerPage: 50
				})
			} else {
				return index.search(query, {
					filters: `named_tags_names:${tag}`,
					distinct: 1,
					hitsPerPage: 50
				})
			}
		}
	}

	function articlesResponse(tag, query) {
		var index = algolia.externals.algoliasearch(
			algolia.config.app_id,
			algolia.config.search_api_key
		).initIndex(
			algolia.config.index_prefix + 'articles',
		)

		return index.search(query, {
			distinct: 1,
			hitsPerPage: 1
		})
	}

	function autocompleteRequest(tag, query) {
		var index = algolia.externals.algoliasearch(
			algolia.config.app_id,
			algolia.config.search_api_key
		).initIndex(
			algolia.config.index_prefix + 'products_query_suggestions',
		)

		return index.search(query, {
			distinct: 1,
			hitsPerPage: 5
		})
	}

	const SearchBanner = {

		selectedFacet: '',
		multiselectedItems: [],
		buildSelectedFacet: function(facet){
			let selectedFacet = '';
			if (facet) {
				switch (facet) {
					case 'BAGS':
						selectedFacet = 'bags'
						break;
					case 'SALES':
						selectedFacet = 'sales'
						break;
					case 'NEW':
						selectedFacet = 'new'
						break;
				}
			}

			this.selectedFacet = selectedFacet;
		},

		changeInputName: function(facet){

			let selectedValues = ''
			if (facet === 'BAGS') {
				SearchBanner.classes.searchForm.querySelector('input').name = 'refinementList[named_tags.bag][0]'
			} else if(facet === 'SALES') {
				SearchBanner.classes.searchForm.querySelector('input').name = 'refinementList[named_tags.sale][0]'
			} else if(facet === 'NEW') {
				SearchBanner.classes.searchForm.querySelector('input').name = 'refinementList[named_tags.sale][0]'
			}
			else if(facet === 'Categories'){
				if(SearchBanner.multiselectedItems.length > 0) {
					selectedValues = SearchBanner.multiselectedItems.map((item, index) => {
						return (`refinementList[named_tags.playerType][${index}]=${item}`)
					}).join('&')
				} else {
					selectedValues = 'q'
				}
				// SearchBanner.classes.searchForm.querySelector('input').value = selectedValues
			}
			SearchBanner.classes.searchForm.querySelector('input').name = '';
		},
		openDropdownSelect: function() {
			if (!document.querySelector(this.classes.parent)) return
			this.classes.facetsSelect.addEventListener('click', function(e){
				e.target.closest('.input-group').classList.toggle('open-select')
			})
		},
		clickOnSeclectOption: function() {
			if (!document.querySelector(this.classes.parent)) return
			const options = this.classes.selectOptions.querySelectorAll('li');

			options.forEach(el => {

				el.addEventListener('click', function(e){
					if(e.target.innerText == document.querySelector('#header .select-result').innerText) return
					const searchResults = ''

					options.forEach(el => el.classList.remove('selected'))

					e.target.classList.add('selected')
					document.querySelector('#header .select-result').innerText = e.target.innerText
					SearchBanner.buildSelectedFacet(e.target.innerText)
					SearchBanner.changeInputName(e.target.innerText)
					SearchBanner.searchResultsBox.classList.add('active')
					SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults
					SearchBanner.hideSearchDropDown()
					SearchBanner.classes.searchForm.querySelector('input').value = ''
					SearchBanner.classes.multiselectedWrapper.classList.remove('active')
					SearchBanner.classes.multiselectedClear.classList.remove('active')
					algoliaShopify.instantsearch.search.helper.setQuery('').search()
				})
			})
		},
		showSearchDropDown: function(){
			SearchBanner.classes.searchResultsBox.classList.add('active')
			SearchBanner.classes.searchResultsDropdown.classList.add('active')
		},
		hideSearchDropDown: function(){
			SearchBanner.classes.searchResultsBox.classList.remove('active')
			SearchBanner.classes.searchResultsDropdown.classList.remove('active')
		},
		getDomElements: function(){
			this.classes = {
				parent: '#header',
				facetsSelect: document.querySelector('#header .category-box'),
				selectOptions: document.querySelector('#header .search-select-text'),
				onSearchInputChange: document.querySelector('#header input.search-form__input.search_banner'),
				searchResultsBox: document.querySelector('#header .header-search-box'),
				searchResultsDropdown: document.querySelector('#header .search-results'),
				searchResultsLi: document.querySelectorAll('#header .search-results li'),
				searchForm: document.querySelector('#header#header .search_baner_form'),
				multiselectedWrapper: document.querySelector('#header .multiselected_values'),
				multiselectedClear: document.querySelector('#header .multiselected_values-clearall'),
			}
		},

		buildFacets: function() {
			if (!document.querySelector(this.classes.parent)) return
			if(algoliaShopify.facets.length <= 0) return
			// const preselectedFacets = ['tags', 'product_type', 'vendor']

			// const facetList = algoliaShopify.facets.map(facet => {
			//   if (preselectedFacets.includes(facet.name)) {
			//     return (
			//       `<li>${facet.title}</li>`
			//     )
			//   }
			// }).join('')
		},


		onSearchInputChange: function() {
			if (!document.querySelector(this.classes.parent)) return
			let searchTimeOut;

			const that = this;

			this.classes.onSearchInputChange.addEventListener('click', function(e){
				if(document.querySelector('#header .select-result').innerHTML === 'Products' || document.querySelector('#header .select-result').innerHTML === 'Brands') {
					return
				}
				clearTimeout(searchTimeOut)

				if(e.target.value != '/.'){
					searchTimeOut = setTimeout(() => {

						async function searchCall() {
							const data = await searchRequest(SearchBanner.selectedFacet, e.target.value);
							const dataArticles = await articlesResponse(SearchBanner.selectedFacet, e.target.value);

							if(dataArticles && dataArticles?.hits?.length > 0 && e.target.value.trim() !== '/.') {
								const parent = new $$('.blog-content').self;

								const searchArticlesResults = dataArticles.hits.map((hit, index) => {
									const badge = hit.tags.length > 0 ? hit.tags[0] : 'tag name';
									const originUrl = window.location.origin;

									parent.innerHTML = `
                    <div class="image">
                			<div class="image-badge">
                				<a href="${originUrl}/blogs/news/${hit.handle}">
                					${badge}
												</a>
											</div>
                			<img class="lazyImage2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" data-src="${hit.image}" alt="${hit.title}">
            				</div>
            				<div>
                			<div class="title">${hit.title}</div>
            				</div>
            				`
								})
							}

							if(data?.hits?.length > 0 && e.target.value.trim() !== '/.'){
								if(SearchBanner.selectedFacet === ''){
									//simple search request query=...
									SearchBanner.onSimpleSearchRequest(data);
								} else if (SearchBanner.selectedFacet === 'bags'){
									// bag tag search request
									SearchBanner.brandSearchRequest(data, 'bag', e.target.value)
								} else if (SearchBanner.selectedFacet === 'new'){
									// player type tag search request
									SearchBanner.playerSearchRequest(data, 'new', e.target.value)
								}  else if (SearchBanner.selectedFacet === 'sale'){
									//player type tag search request
									SearchBanner.playerSearchRequest(data, 'sale', e.target.value)
								}
							} else {
								const noResults = '<li style="color: tomato">No results</li>'
								SearchBanner.classes.searchResultsDropdown.innerHTML = noResults
								SearchBanner.showSearchDropDown()
							}

							let array = [];
							data.hits.forEach(hit => {
								hit['collections'].forEach(collection => {
									collection.toLowerCase() !== 'frontpage' && array.push(collection);
								})
							})

							const new_array = [...new Set(array)].splice(0, 7);

							const html_collections = new_array.map(collection => {
								return `<li data-handle="${collection}" class="categories-item">${collection.split('-').join(' ')}</li>`;
							}).join(' ');

							that.classes.facetsSelect.querySelector('.categories').innerHTML = html_collections;

							const el_click_collection = new $$('.categories .categories-item');
							that.toggle_click_search(el_click_collection);
						}

						searchCall()
					}, 0);
				} else {
					const searchResults = ''
					SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults
					SearchBanner.hideSearchDropDown()
				}
			})

			this.classes.onSearchInputChange.addEventListener('keyup', function(e){
				if( document.querySelector('#header .select-result').innerHTML === 'Player Type') {
					return
				}
				clearTimeout(searchTimeOut);

					if(e.target.value !== '/.'){
						document.querySelector('#header .search-item').innerHTML = `"${e.target.value}"`;

					searchTimeOut = setTimeout(() => {
						async function searchCall() {
							const data = await searchRequest(SearchBanner.selectedFacet, e.target.value);
							const dataArticles = await articlesResponse(SearchBanner.selectedFacet, e.target.value);

							let autocomplete = null;
							if (e.target.value.length > 2) {
								autocomplete = await autocompleteRequest(SearchBanner.selectedFacet, e.target.value);
							} else {
								autocomplete = null;
							}

							if(data?.hits?.length > 0 && e.target.value.trim() !== '/.'){

								let array = [];
								data.hits.forEach(hit => {
									hit['collections'].forEach(collection => {
										collection.toLowerCase() !== 'frontpage' && array.push(collection);
									})
								})

								const new_array = [...new Set(array)].splice(0, 7);

								const html_collections = new_array.map(collection => {
									return `<li data-handle="${collection}" class="categories-item">${collection.split('-').join(' ')}</li>`;
								}).join(' ');

								that.classes.facetsSelect.querySelector('.categories').innerHTML = html_collections;

								const el_click_collection = new $$('.categories .categories-item');
								that.toggle_click_search(el_click_collection);

								if(SearchBanner.selectedFacet === ''){
									//simple search request query=...
									SearchBanner.onSimpleSearchRequest(data)
								} else if (SearchBanner.selectedFacet === 'bags'){
									//brand tag search request
									SearchBanner.brandSearchRequest(data, 'bag', e.target.value)
								} else if (SearchBanner.selectedFacet === 'playerType'){
									//player type tag search request
									SearchBanner.playerSearchRequest(data, 'playerType', e.target.value)
								}
							} else {
								const noResults = '<li style="color: tomato">No results</li>'
								SearchBanner.classes.searchResultsDropdown.innerHTML = noResults
								SearchBanner.showSearchDropDown()
							}

							if(dataArticles && dataArticles?.hits?.length > 0 && e.target.value.trim() != '/.') {
								const parent = new $$('.blog-content').self;

								const searchArticlesResults = dataArticles.hits.map((hit, index) => {
									const badge = hit.tags.length > 0 ? hit.tags[0] : 'tag name';
									const originUrl = window.location.origin;

									parent.innerHTML = `
                    					<div class="image">
                							<div class="image-badge">
                								${badge}
											</div>
											<a href="${originUrl}/blogs/news/${hit.handle}">
                								<img src="${hit.image}" alt="${hit.title}">
                							</a>
            							</div>
            							<div>
                							<div class="title">${hit.title}</div>
            							</div>
            						`
								})
							}

							if(autocomplete && autocomplete?.hits?.length > 0 && e.target.value.trim() != '/.'){
								document.querySelector('#header-list').innerHTML = '';
								autocomplete.hits.forEach(item => {
									const el = document.createElement('li');
									el.classList.add('list-item');
									el.innerHTML = item.query;
									document.querySelector('#header-list').append(el);
								})
							} else {
								document.querySelector('#header-list').innerHTML = '';
							}

							const el_click = new $$('#header-list .list-item');
							that.toggle_click_search(el_click);

						}

						searchCall()
					}, 0);
				} else {
					const searchResults = ''
					SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults
					SearchBanner.hideSearchDropDown()
				}

				new $$('.search-button.go-search').self.href = `/search?q=${e.target.value}` ;
			})
		},
		toggle_click_search: function (elements) {
			elements.on('click', (element) => {
				const form_input = new $$('#header .search-form__input').self;
				document.querySelector('#header .go-search').href = `/search?q=${element.innerHTML}`;
				if(element.dataset.handle) {
					form_input.value = element.dataset.handle;
				} else {
					form_input.value = element.innerHTML;
				}
				form_input.click();
			})
		},
		onSearchResultClick: function() {
			document.addEventListener('click', function(e){
				if(SearchBanner.selectedFacet == 'playerType'){
					if (e.target.closest('.search-results li .checkbox-label')) {
						setTimeout(() => {
							SearchBanner.buildMultiselectedArr()
							SearchBanner.buildMultiselectedItems()
							SearchBanner.changeInputName('Player Type')
						}, 0);
						// const inputValue = e.target.closest('.product-options__checkbox-content').querySelector(SearchBanner.searchResultsCheckbox).value
						// SearchBanner.classes.searchForm.querySelector('input').value = e.target.innerText
						// SearchBanner.hideSearchDropDown()
					}
				} else {
					if (e.target.closest('.search-results li')) {
						SearchBanner.classes.searchForm.querySelector('input').value = e.target.innerText;
						SearchBanner.hideSearchDropDown()
					}
				}
			})
		},
		buildMultiselectedArr: function(){
			SearchBanner.multiselectedItems = []

			document.querySelectorAll('.search-results li').forEach(checkbox => {
				if(checkbox.querySelector('.radio-button').checked){
					SearchBanner.multiselectedItems.push(checkbox.querySelector('.radio-button').value)
				}
			})
		},
		buildMultiselectedItems: function(){
			let selectedCheckboxes = ''

			if(SearchBanner.multiselectedItems.length > 0){
				let selectedCheckboxes = SearchBanner.multiselectedItems.map((item, index) => {
					return (
						`<div class="multiselected_values-item">
              <span class="multiselected_value">${item}</span>
              <span class="multiselected_values-clear">x</span>
              <input type="hidden" name="refinementList[named_tags.playerType][${index}]" value="${item}" aria-hidden="true"/>
            </div>`
					)
				}).join('')

				SearchBanner.classes.multiselectedWrapper.innerHTML = selectedCheckboxes
				SearchBanner.classes.multiselectedWrapper.classList.add('active')
				SearchBanner.classes.multiselectedClear.classList.add('active')
			} else {
				SearchBanner.classes.multiselectedWrapper.innerHTML = selectedCheckboxes
				SearchBanner.classes.multiselectedWrapper.classList.remove('active')
				SearchBanner.classes.multiselectedClear.classList.remove('active')

			}
		},
		clearAll: function(){
			$(document).on('click', '.multiselected_values-clearall', function(e) {
				SearchBanner.multiselectedItems.length = 0;
				SearchBanner.classes.multiselectedWrapper.classList.remove('active')
				SearchBanner.classes.multiselectedClear.classList.remove('active')
				SearchBanner.classes.searchResultsBox.classList.remove('active')
				SearchBanner.classes.searchResultsDropdown.classList.remove('active')
				var arr_input = document.querySelectorAll('.search-results li .radio-button');
				Array.from(arr_input).findIndex(item => item.checked = false);
				document.querySelector('.search-form__input.search_banner').value = '';
				// console.log('selectedValues', SearchBanner.multiselectedItems)
				SearchBanner.multiselectedItems.length = 0;
				if($(this)[0].children[0].classList.contains('close-list')){
					this.children[0].classList.remove('close-list')
				}
				Array.from(SearchBanner.classes.searchForm.querySelectorAll('input')).forEach(item => {
					item.name = ''
					item.value = ''
				})
				algoliaShopify.instantsearch.search.helper.setQuery('').clearRefinements().search()
			});
		},
		removeMultiselected: function(){
			$(document).mouseup( function (e) {
				var select = $('.search-form');
				var option = $('.search-form .search-results');
				var option_box = $('.search-form .header-search-box');
				if (e.target != select[0] && select.has(e.target).length === 0 && option.hasClass('active')){
					option.removeClass('active')
					option_box.removeClass('active');

					if($('.multiselected_values-clearall').hasClass('active')){
						$('.multiselected_values-clearall.active')[0].children[0].classList.add('close-list')
					}
				}
			});
			$(document).on('click', '.multiselected_values-item', function(e) {
				var removeActive = Array.from(document.querySelectorAll('.search-results li')).find(item => item.innerText === this.children[0].innerText);
				if(this.parentElement.childElementCount === 1){
					this.parentElement.classList.remove('active');
					SearchBanner.classes.multiselectedClear.classList.remove('active');
					SearchBanner.classes.searchResultsBox.classList.remove('active');
					SearchBanner.classes.searchResultsDropdown.classList.remove('active');
				}
				this.remove();
				removeActive.children[0].children[0].checked = false;
			})
		},
		inputValue: function(){
			if(algoliaShopify.instantsearch.search.helper.state.query.split('[')[0] == 'refinementList'){
				document.querySelector('#input-search-text').value = '';
			}else{
				document.querySelector('#input-search-text').value = algoliaShopify.instantsearch.search.helper.state.query;
			}
		},
		buttonSubmit: function(){
			if (algolia.full_results || algolia.is_collection_results_page) {
				$(document).on('click', '.search-form__connected-submit', function(e) {
					e.preventDefault();
					if(document.querySelector('.select-result').innerHTML == 'Player Type'){
						let selectedValues = ''
						if(SearchBanner.multiselectedItems.length > 0) {
							selectedValues = SearchBanner.multiselectedItems.map((item, index) => {
								return (`refinementList[named_tags.playerType][${index}]=${item}`)
							}).join('&')
						}
						algoliaShopify.instantsearch.search.helper.setQuery(selectedValues).search()
					}else{
						algoliaShopify.instantsearch.search.helper.setQuery(document.querySelector('.search-form__input.search_banner').value).search()
					}
				})
			}
		},
		onSimpleSearchRequest: function(data){
			// console.log(data)
			const searchResults = data.hits.map((hit, index) => {

				if(index <= 2) {
					const results_length = data.hits.length;
					if(results_length > 30) {
						document.querySelector('#header .search-elements').innerHTML = `Products (30+)`
					} else {
						document.querySelector('#header .search-elements').innerHTML = `Products (${results_length})`
					}
					// console.log(hit, 'hit')
					return (
						`<li class="list-item">
                			<div class="product-box">
                    			<a class="product-handle" href="/products/${hit.handle}">
                        			<div class="image">
                            			<img class="lazyImage2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" data-src="${hit.image}" alt="${hit.title}">
                        			</div>

                        			<div class="box-text">
                      	    			<div class="title">${hit.title}</div>
																	<div class="price-container">
																		<div class="${hit.compare_at_price != 0 ? 'compare_at_price': 'hidden'}">$${hit.compare_at_price}</div>
																		<div class="${hit.compare_at_price != 0 ? 'sale-price': 'price'}">
																		<span class="max-price">$${hit.variants_max_price}</span>
																		</div>
																	</div>
                         			</div>
                    			</a>
            				</div>
           				</li>
						`
					)
				}

			}).join('')

			SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults;
			SearchBanner.showSearchDropDown()
		},
		brandSearchRequest: function(data, tag, query) {
			let namedTags = data.hits.map(hit => {
				return Array.isArray(hit.named_tags[tag]) ?
					hit.named_tags[tag].map(tag => tag.trim())
					:
					[...[], hit.named_tags[tag].trim()]
			})
			namedTags = namedTags.flat()

			const searchValues = namedTags
				.filter((item, index) => namedTags.indexOf(item) === index)
				.filter(hit => {
					if (hit.toLowerCase().includes(query.toLowerCase())) {
						return hit
					}
				})

			const searchResults = searchValues.length > 0 ?
				searchValues.map(value => {
					return (
						`<li>${value}</li>`
					)
				}).join('')
				:
				searchValues.map(() => {
					return (
						`<li style="color: tomato">No results</li>`
					)
				}).join('')

			SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults
			SearchBanner.showSearchDropDown()
		},
		playerSearchRequest: function(data, tag, query){
			// search?refinementList[named_tags.playerType][0]=Test Brand
			// search?refinementList[named_tags.playerType][0]=Test Brand&refinementList[named_tags.playerType][1]=NEW Fairway Jockey

			let namedTags = data.hits.map(hit => {
				return Array.isArray(hit.named_tags[tag]) ?
					hit.named_tags[tag].map(tag => tag.trim())
					:
					[...[], hit.named_tags[tag].trim()]
			})
			namedTags = namedTags.flat()

			const searchValues = namedTags
				.filter((item, index) => namedTags.indexOf(item) === index)
			// .filter(hit => {
			//   if (hit.toLowerCase().includes(query.toLowerCase())) {
			//     return hit
			//   }
			// })

			const searchResults = searchValues.length > 0 ?
				searchValues.map((value, index) => {
					return (
						`<li>
              				<div class="product-options__checkbox-content">
                				<input class="radio-button" name="" type="checkbox" value="${value}" id="checkbox-${index}">
                				<label class="checkbox-label" for="checkbox-${index}">${value}</label>
              				</div>
            			</li>`
					)
				}).join('')
				:
				searchValues.map(() => {
					return (
						`<li style="color: tomato">No results</li>`
					)
				}).join('')

			SearchBanner.classes.searchResultsDropdown.innerHTML = searchResults
			SearchBanner.showSearchDropDown()
		},
		init: function() {
			this.getDomElements()
			this.buildFacets()
			this.openDropdownSelect()
			this.clickOnSeclectOption()
			this.onSearchInputChange()
			this.onSearchResultClick()
			this.removeMultiselected()
			this.clearAll()
			this.buttonSubmit()
			// this.onSearch()
			//this.inputValue()
		}
	}
	// window.addEventListener('DOMContentLoaded', () => {
	// 	setTimeout(() => {
	// 		SearchBanner.init()
	// 	}, 0);
	// });


			SearchBanner.init()


}(algoliaShopify));
